import { defaultHTTPRequests } from "../http-request-service";

export const paths = {
    IMPORT_IDLAVORAZIONI: '/pml/lavorazioni/import',
    IMPORT_ORDINIFORNITORE: '/pml/purchaseOrder/import?feedback=:feedback',
    IMPORT_POLLINGROWS: '/pml/uploader/uplfile/:uuid/rows?sort=rowNum&order=asc',
    IMPORT_DATEPREVISIONALICONSEGNA: '/pml/purchaseOrder/import?feedback=DATE',
    IMPORT_ORDINI_ATS: '/pml/purchaseOrder/import?feedback=ORDINI',
    IMPORT_EM: '/pml/importmassive/file?entityTypeEnum=EM',
    IMPORT_EM_MASSIVE: '/pml/importmassive/file?entityTypeEnum=EM_MASSIVE',
    IMPORT_BONIFICHE_FAILURE_RIPARATI: '/pml/import/bonifichefailureRiparati',
    FILE_STATUS: '/pml/uplfile/:uuid',
    RESULT_IMPORT: '/pml/export/importresult/:uuid',
    RESULT_IMPORT_FR: '/pml/export/importresult/fr/:uuid',
    RESULT_IMPORT_FILE: '/pml/export/importresults/file/:uuid',
    IMPORT_FAILUREREPORT: '/pml/failurereport/import',
    IMPORT_GIACENZA_VOLANO: '/pml/giacenzavolano/import?feedback=GIACENZA_VOLANO',
    IMPORT_SURVEY: '/pml/importmassive/file/survey',
    GET_ALERTS: '/pml/alerts/active'
}

export const IMPORT_IDLAVORAZIONI = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_IDLAVORAZIONI, null, body);
}

export const RESULT_IMPORT = (uuid) => {
    return defaultHTTPRequests("EXPORT", paths.RESULT_IMPORT.replace(/:uuid/gi, uuid), null);
}

export const RESULT_IMPORT_FR = (uuid) => {
    return defaultHTTPRequests("EXPORT", paths.RESULT_IMPORT_FR.replace(/:uuid/gi, uuid), null);
}

export const RESULT_IMPORT_FILE = (uuid,param) => {
    return defaultHTTPRequests("EXPORT", paths.RESULT_IMPORT_FILE.replace(/:uuid/gi, uuid), param);
}

export const IMPORT_ORDINI_ATS = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_ORDINI_ATS, null, body);
}

export const IMPORT_EM = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_EM, null, body);
}

export const IMPORT_EM_MASSIVE = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_EM_MASSIVE, null, body);
}

export const IMPORT_GIACENZA_VOLANO = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_GIACENZA_VOLANO, null, body);
}

export const IMPORT_ORDINIFORNITORE = (body, feedback) => {
    return defaultHTTPRequests('POST', paths.IMPORT_ORDINIFORNITORE.replace(/:feedback/gi, feedback), null, body);
}

export const IMPORT_DATEPREVISIONALICONSEGNA = (body, feedback) => {
    return defaultHTTPRequests('POST', paths.IMPORT_DATEPREVISIONALICONSEGNA, null, body);
}

export const IMPORT_POLLINGROWS = (uuid) => {
    return defaultHTTPRequests('GET', paths.IMPORT_POLLINGROWS.replace(/:uuid/gi, uuid), null);
}

export const GET_FILE_STATUS = (uuid) => {
    return defaultHTTPRequests('GET', paths.FILE_STATUS.replace(/:uuid/gi, uuid), null);
}
export const IMPORT_FAILUREREPORT = (body) => {
    return defaultHTTPRequests('POST', paths.IMPORT_FAILUREREPORT, null, body);
}
export const IMPORT_BONIFICHE_FAILURE_RIPARATI = (body) => {
    return defaultHTTPRequests('IMPORT_EXPORT', paths.IMPORT_BONIFICHE_FAILURE_RIPARATI,null, body);
}

export const IMPORT_SURVEY = (body, definition) => {
    return defaultHTTPRequests('POST', paths.IMPORT_SURVEY.concat(definition),null, body);
}

export const GET_ALERTS = () => {
    return defaultHTTPRequests('GET', paths.GET_ALERTS, null);
}
